import { createAction } from "@reduxjs/toolkit";

import type { NodeAction } from "@skilitics/nautilus-core";

export type Mutable<T> = {
  -readonly [P in keyof T]: T[P] extends (infer R)[]
    ? Mutable<R>[]
    : T[P] extends ReadonlyArray<infer R>
      ? Mutable<R>[]
      : T[P] extends object
        ? Mutable<T[P]>
        : T[P];
};

export const withPayloadType =
  <T>() =>
  (payload: T) => ({ payload });

export const createNodeDesignsAction = <T extends NodeAction & { payload: unknown }>(type: T["type"]) =>
  createAction(type, withPayloadType<T["payload"]>());
